const deleteRoles = {
  toastr: 'Deleted site',
  toastr1: ' successfully deleted'
};

export default deleteRoles;
